import { render, staticRenderFns } from "./DashboardChartHeader.vue?vue&type=template&id=04e05377"
import script from "./DashboardChartHeader.vue?vue&type=script&lang=js"
export * from "./DashboardChartHeader.vue?vue&type=script&lang=js"
import style0 from "./DashboardChartHeader.vue?vue&type=style&index=0&id=04e05377&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports